module.exports = __webpack_public_path__ + "public/images/slider/peremutov.7cb2ad6eefb27095985d6340252fff2f.webp";